"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var utils_1 = require("./utils");
exports.getChannelSubscription = function (channel) {
    var _a;
    if (channel) {
        var isEntitled = (_a = channel.viewingMethods) === null || _a === void 0 ? void 0 : _a.some(function (viewingMethod) {
            var _a;
            var linearViewingMethod = viewingMethod;
            return ((linearViewingMethod === null || linearViewingMethod === void 0 ? void 0 : linearViewingMethod.__typename) === 'LinearViewingMethod' &&
                (ramda_1.isEmpty(linearViewingMethod === null || linearViewingMethod === void 0 ? void 0 : linearViewingMethod.packages) || ((_a = linearViewingMethod === null || linearViewingMethod === void 0 ? void 0 : linearViewingMethod.packages) === null || _a === void 0 ? void 0 : _a.some(function (pkg) { return utils_1.isNotNilOrEmpty(pkg === null || pkg === void 0 ? void 0 : pkg.mySubscription); }))));
        });
        return !!isEntitled;
    }
    return false;
};
exports.getVodSubscription = function (vodContent) {
    var _a;
    if (vodContent) {
        var isEntitled = (_a = vodContent.viewingMethods) === null || _a === void 0 ? void 0 : _a.some(function (viewingMethod) {
            var _a;
            var vodViewingMethod = viewingMethod;
            return ((vodViewingMethod === null || vodViewingMethod === void 0 ? void 0 : vodViewingMethod.__typename) === 'VodViewingMethod' &&
                (ramda_1.isEmpty(vodViewingMethod === null || vodViewingMethod === void 0 ? void 0 : vodViewingMethod.packages) || ((_a = vodViewingMethod === null || vodViewingMethod === void 0 ? void 0 : vodViewingMethod.packages) === null || _a === void 0 ? void 0 : _a.some(function (pkg) { return utils_1.isNotNilOrEmpty(pkg === null || pkg === void 0 ? void 0 : pkg.mySubscription); }))));
        });
        return !!isEntitled;
    }
    return false;
};
exports.getSlotSubscriptions = function (slot) {
    if (slot) {
        return exports.getChannelSubscription(slot.channel);
    }
    return false;
};
exports.isChannelEntitled = function (channel) {
    var requiredSubscriptions = exports.getChannelSubscription(channel);
    return !!requiredSubscriptions;
};
exports.isVodEntitled = function (vodContent) {
    var requiredSubscriptions = exports.getVodSubscription(vodContent);
    return !!requiredSubscriptions;
};
//# sourceMappingURL=Entitlements.js.map